export default {
  NODE_ENV: "production",
  API_URL: "https://api-tg.telphin.ru",
  TG_BOT_URL: "https://t.me/TelphinBot",
  MAX_BOT_URL: "https://max.ru/id7814466467_2_bot",
};
